export const TAB_IDS = {
  TEAM: "team",
  PERMISSIONS: "permissions"
};
